import React from 'react';
import GhostButton, { GhostButtonProps } from '../../../Buttons/GhostButton';
import { useDropdownToggleProps } from '../../hooks/useDropdownToggleProps';
import type { ComponentRequiresAriaHasPopup } from '../types';

export interface Props
  extends Omit<GhostButtonProps, 'aria-haspopup'>, ComponentRequiresAriaHasPopup {}

/**
 * A wrapper around our DS `GhostButton` that provides the props for a dropdown toggle.
 *
 * Note: This component is only the toggle! It doesn't contain a popover or dropdown. If you're looking for something that does,
 * you probably want a preset instead of this. Consider `GhostButtonWithContextMenu`.
 *
 * Required contexts: `PopperDropdownContext`, `DropdownStateContext`
 */
const PopperGhostToggleButton: React.FC<Props> = props => {
  const necessaryToggleProps = useDropdownToggleProps();

  return <GhostButton {...necessaryToggleProps} {...props} />;
};
PopperGhostToggleButton.displayName = 'PopperGhostToggleButton';

export default PopperGhostToggleButton;
